import controller from './side-banners.controller';
import templateBase from './templates/side-banners-base.view.html';

let SideBannersComponent = {
  template: templateBase,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  return templateBase;

}

export default SideBannersComponent;



// WEBPACK FOOTER //
// ./www/components/shared/components/banners/side-banners/side-banners.component.js